import animationFrameWait from '@/utils/animationFrameWait';
import { isPrerenderBuild } from '@/utils/publicSite';

const getCurrentPrerenderPath = () => `${window.location.pathname}${window.location.search}${window.location.hash}`;

const setPrerenderState = (ready: boolean, path = getCurrentPrerenderPath()) => {
  if (!isPrerenderBuild()) return;

  window.__BC_PRERENDER_ROUTE = path;
  window.__BC_PRERENDER_READY = ready;
};

export const resetPrerenderReady = (path?: string) => {
  setPrerenderState(false, path);
};

export const markPrerenderReady = (path?: string) => {
  setPrerenderState(true, path);
};

export const schedulePrerenderReady = async (path?: string, frames = 2) => {
  if (!isPrerenderBuild()) return;

  await animationFrameWait(frames);
  markPrerenderReady(path);
};
